export { SlideTextSizeButton } from "#slide-text-size-button";
